export default __webpack_public_path__ + "static/media/pic1.1dfc3cf5.jpg";